import React from 'react';
import { useState, useEffect } from "react";
import Swal from "sweetalert2";
import { Row, Col, Button } from "reactstrap";
import Sidebar from '../../Sidebar';
import { useNavigate } from 'react-router';
import { useCookies } from 'react-cookie';
import { moment } from 'moment';
import { useLocation, Link,useParams } from 'react-router-dom';
import {displayErrorToast,parseBoolean,displayError,parseBooleanToString} from '../../helpers';
import ErrorToast from '../../ErrorToast';
import FloatingControls from '../../components/FloatingControls';
import LoadingOverlay from '../../components/LoadingOverlay';
import SummaryIcon from '../../components/SummaryIcon';
import { getHTMLForSummaryPopup } from '../../utils/PopupUtils';
import { getCurrentDate, getCurrentTime} from '../../utils/DateUtils';
import { getCustomerSiteDetails,getAllCustomerSites } from '../../services/CustomerSiteServices';
import { getCustomerMainDetails} from '../../services/CustomerMainServices';
import { getCompanyDetails} from '../../services/CompanyServices';
import { getAllPlants,getPlantDetails } from '../../services/PlantServices';
import { getAllEquipments, getEquipmentsDetails } from '../../services/EquipmentServices';
import { updateDeliveryChallan,getAllDeliveryChallans,getDropdownOptions,cancelDeliveryChallan,reactivateDeliveryChallan,getDeliveryChallanDetails, deleteDeliveryChallan,getDeliveryChallanEmail } from '../../services/DeliveryChallanServices';
import { getSalesOrderDetails } from '../../services/SalesOrderServices';
import { getDesignMixForWorkSchedule } from '../../services/DesignMixServices';
import { getAllProducts } from '../../services/ProductServices';
import { getAllWorkSchedules, getWorkScheduleForDeliveryChallan,getWorkScheduleDetails } from '../../services/WorkScheduleServices';
import { getDisplayDate } from '../../utils/DateUtils';
import { showBillingPop, showCustomerSitePop, showProjectrPop, showSalesorderPop, showWorkschedulePop, displayDeliveryChallanSaveError, getWeighmentValidationError, openDesignMixPopup, isDcVehicleReady, getDcConfirmContext, buildDcSaveConfirmHtml, promptSelectVehicleBeforeQty } from './DeliveryChallanUtils';
import NumberSetting from '../../components/NumberSetting';
import { getAllPlantConfigurations } from '../../services/PlantConfigurationServices';
import EditSharpIcon from '@mui/icons-material/EditSharp';
import DmixIcon from '../../components/DmixIcon';
import Creatable from "react-select/creatable";
import Select from "react-select";
import PremiumPageHeader from '../../components/PremiumPageHeader';
import { clearFormDraft, DELIVERY_CHALLAN_CREATE_DRAFT_KEY, DELIVERY_CHALLAN_EDIT_DRAFT_KEY, readInitialFormDraft, saveFormDraft, navigateToNewForm } from '../../utils/formDraft';
import DeliveryChallanScheduleBanner from './DeliveryChallanScheduleBanner';


function DeliveryChallanEdit() {
  const location = useLocation();
  const { id } = useParams();
  const restoredDraft = readInitialFormDraft(DELIVERY_CHALLAN_EDIT_DRAFT_KEY);
  const isRestoredEdit = Boolean(
    restoredDraft?.inputs && String(restoredDraft.recordId) === String(id)
  );
  const [cookies] = useCookies(['myToken']);
  const [userName] = useCookies(['myName']);
  const [userId] = useCookies(['myUserId']);
  const [category] = useCookies(['myCategory']);
  const [superuser] = useCookies(['mySuperuser']);
  const [inputs, setInputs] = useState(isRestoredEdit ? restoredDraft.inputs : {});
  const [inProgress, setInProgress] = useState(false);
  const [initial_dc_qty, setInitialDcQty] = useState(isRestoredEdit ? restoredDraft.initial_dc_qty : 0);
  const [initial_cum_qty, setInitialCumQty] = useState(isRestoredEdit ? restoredDraft.initial_cum_qty : 0);
  const [equipments, setEquipments] = React.useState(isRestoredEdit ? (restoredDraft.equipments || []) : []);
  const [userplants, setUserPlant] = React.useState([]);
  const [customervehicles,setCustomerVehicles] =React.useState(isRestoredEdit ? restoredDraft.customervehicles : [{ value: '', label: '' }]);
  const [error, setError] = useState({});
  const [selectedWorkSchedule,setSelectedWorkSchedule] = useState(isRestoredEdit ? restoredDraft.selectedWorkSchedule : {});
  const [isLoading, setIsLoading] = useState(!isRestoredEdit);  
  const [workschedules,setWorkschedules]=React.useState(isRestoredEdit ? (restoredDraft.workschedules || []) : []);
  const [filteredplants,setFilteredPlants] = useState(isRestoredEdit ? (restoredDraft.filteredplants || []) : []);
  const [allWorkschedules,setAllWorkschedules] = useState(isRestoredEdit ? (restoredDraft.allWorkschedules || []) : []);
  const [finishedgoods, setFinishedGoods] = React.useState(isRestoredEdit ? (restoredDraft.finishedgoods || []) : []);
  const [plants,setPlants] =React.useState([]);
  const [isSubmitting, setIsSubmitting] = useState(true);
  const navigate = useNavigate();
  const [selectedCustomer,setSelectedCustomer]=React.useState(isRestoredEdit ? (restoredDraft.selectedCustomer || {}) : {})
  const [selectedSite,setSelectedSite]= React.useState(isRestoredEdit ? (restoredDraft.selectedSite || {}) : {});
  const [plantConfig,setPlantConfig] = React.useState(isRestoredEdit ? (restoredDraft.plantConfig || []) : []);
  const [showModal2, setShowModal2] = useState(false);
  const [options, setOptions] = useState(isRestoredEdit ? (restoredDraft.options || [{ value: '', label: '' }]) : [{ value: '', label: '' }]);
  const [drivers, setDrivers] = useState(isRestoredEdit ? (restoredDraft.drivers || [{ value: '', label: '' }]) : [{ value: '', label: '' }]);
  const [selectedOperator, setSelectedOperator] = useState(isRestoredEdit ? restoredDraft.selectedOperator : '');
  const [selectedDriver, setSelectedDriver] = useState(isRestoredEdit ? restoredDraft.selectedDriver : '');
  const [selectedVehicle, setSelectedVehicle] = useState(isRestoredEdit ? restoredDraft.selectedVehicle : '');
  const [isCheckedIn, setIsCheckedIn] = useState(Boolean(isRestoredEdit && restoredDraft.isCheckedIn));
    const handleCreatable = (selected) => {
      setSelectedOperator(selected);
      console.log("Selected Option:", selected);
    };
  
    const handleDriver = (selected) => {
      setSelectedDriver(selected);
      console.log("Selected driver:", selected);
    };

  const applyWeighmentWeights = (values, tareOverride, actualOverride) => {
    const tare = Math.round(
      tareOverride !== undefined
        ? (Number(tareOverride) || 0)
        : (Number(values.tare_weight) || 0)
    );
    const actual = Math.round(
      actualOverride !== undefined
        ? (Number(actualOverride) || 0)
        : (Number(values.net_weight) || 0)
    );
    return {
      ...values,
      tare_weight: tare,
      net_weight: actual,
      gross_weight: tare + actual,
    };
  };

    const handleVehicleChange = (selected) => {
      setSelectedVehicle(selected);
      const tare = Number(selected?.empty_weight) || 0;
      setInputs((values) => ({
        ...applyWeighmentWeights(values, tare),
        opening_km: Number(selected?.co_open_km) || 0,
        opening_hm: Number(selected?.co_open_hm) || 0,
      }));
    };

  const saveEditDraft = (extra = {}) => {
    saveFormDraft(DELIVERY_CHALLAN_EDIT_DRAFT_KEY, {
      recordId: id,
      inputs,
      selectedVehicle,
      selectedOperator,
      selectedDriver,
      selectedWorkSchedule,
      selectedCustomer,
      selectedSite,
      workschedules,
      allWorkschedules,
      filteredplants,
      plantConfig,
      options,
      drivers,
      customervehicles,
      finishedgoods,
      initial_dc_qty,
      initial_cum_qty,
      equipments,
      isCheckedIn,
      ...extra,
    });
  };

  const openEquipmentForEmptyWeight = () => {
    const equipmentId = selectedVehicle?.value || selectedVehicle;
    if (!equipmentId || inputs.transport_mode === 'customer') {
      Swal.fire('Select an own vehicle first to edit Empty Weight / Tare.', '', 'info');
      return;
    }
    saveEditDraft({ reopenWeighmentModal: true });
    navigate(`/EquipmentEdit/${equipmentId}/?returnTo=${encodeURIComponent(location.pathname)}`, {
      state: { returnTo: location.pathname },
    });
  };

  React.useEffect(() => {
    if (restoredDraft && !isRestoredEdit) {
      clearFormDraft(DELIVERY_CHALLAN_EDIT_DRAFT_KEY);
    }
  }, []);

  React.useEffect(() => {
    if (!isRestoredEdit) {
      return;
    }
    const mode = restoredDraft.inputs.transport_mode;
    const customerVehicleEl = document.getElementById('customer_vehicle_no');
    const vehicleEl = document.getElementById('vehicle_id');
    if (customerVehicleEl && vehicleEl) {
      if (mode === 'customer') {
        customerVehicleEl.style.display = 'block';
        vehicleEl.style.display = 'none';
      } else {
        customerVehicleEl.style.display = 'none';
        vehicleEl.style.display = 'block';
      }
    }
    const transportModeEl = document.getElementById('transport_mode');
    if (transportModeEl && restoredDraft.selectedWorkSchedule?.sales_order_detail?.sales_order?.transport_mode) {
      const wsMode = restoredDraft.selectedWorkSchedule.sales_order_detail.sales_order.transport_mode;
      if (wsMode === 'own' || wsMode === 'customer') {
        transportModeEl.disabled = true;
      }
    }
    setIsLoading(false);
    setInProgress(false);
  }, []);

  React.useEffect(() => {
    if (!isRestoredEdit || !restoredDraft?.reopenWeighmentModal) {
      return;
    }
    setShowModal2(true);
    saveFormDraft(DELIVERY_CHALLAN_EDIT_DRAFT_KEY, {
      ...restoredDraft,
      reopenWeighmentModal: false,
    });
    const equipmentId = restoredDraft?.selectedVehicle?.value || restoredDraft?.selectedVehicle;
    if (!equipmentId || !cookies?.myToken) {
      return;
    }
    getEquipmentsDetails(cookies, equipmentId)
      .then((equipment) => {
        const tare = Number(equipment.empty_weight) || 0;
        setInputs((values) => applyWeighmentWeights(values, tare));
        setSelectedVehicle((prev) => (
          prev && typeof prev === 'object'
            ? { ...prev, empty_weight: tare }
            : prev
        ));
      })
      .catch(() => {});
  }, []);

  React.useEffect(() => {
      if (isRestoredEdit) {
        return;
      }
      setInputs(values => ({...values,
          ['delivery_challan_date']: getCurrentDate(),
          ['delivery_challan_time']: getCurrentTime(),
        
      }))
  }, []);
     
  React.useEffect(() => {
      getAllPlants(cookies)
      .then (
          plantList => {
              const plant = plantList.plant_list.filter(obj => obj.status).map(
                  plant => {
                      return { value: plant.id, label: plant.plant_alias }
                  }
              );
              setPlants(plant);
          }
      )
  }, []);

  React.useEffect(() => {
    getAllWorkSchedules(cookies)
      .then (
          workscheduleList => {
              const workschedules = workscheduleList.work_schedule_list.map(
                workschedule => {
                  return { value: workschedule.id, 
                      label: workschedule.schedule_no}
                      //  + "-" + workschedule.sales_order_detail.prefix + workschedule.sales_order_detail.order_no + "(" + workschedule.sales_order_detail.product.name + ")"}
                  }
              );
              console.log(JSON.stringify(workschedules)+"work_schedule_list")
              setWorkschedules(workschedules);
          }
      )
  }, []);

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    try
    {
      setInputs(values => ({...values, [name]: value}));
      if(name === 'plant_id' && value){
          setIsLoading(true);
          getWorkScheduleForDeliveryChallan(cookies,value)
          .then( workscheduleList => {
            const workschedules = workscheduleList.work_schedule_list.map(
                workschedule => {
                    return { value: workschedule.id, 
                      label: workschedule.schedule_no + "-" + workschedule.sales_order_detail.sales_order.prefix + workschedule.sales_order_detail.sales_order.order_no + "(" + workschedule.sales_order_detail.product.name + ")"}
                }
            );
            setWorkschedules(workschedules);
            setAllWorkschedules(workscheduleList.work_schedule_list)
          })
          .catch((error) =>
          {
              setIsLoading(false);
              console.log(error?.response?.data);
              displayError(error?.response?.data || error?.message || error," Failed");
          })
      } 
      else if (name === 'plant_id' && !value) {
          setInputs(values => ({...values, ['delivery_challan_no']: ''}));
      }
      else if(name === 'transport_mode')
      {
        if(value === 'customer')
        {
          document.getElementById('customer_vehicle_no').style.display="block";
          document.getElementById('vehicle_id').style.display="none";
        }
        else if(value === 'own')
        {
          document.getElementById('customer_vehicle_no').style.display="none";
          document.getElementById('vehicle_id').style.display="block";
        }
      }
    }
    catch (e) {
      displayErrorToast(e);
    }
    setInputs(values => ({...values, [name]: event.target.value}))
  }
 
  const handleVehicleDetailsIconClick = () => {
    setShowModal2(true);
  };      

  const handleDeliveryChallanQty = (event)=>{
    const name = event.target.name;
    const value = event.target.value;
    if (!isDcVehicleReady(inputs, selectedVehicle)) {
      promptSelectVehicleBeforeQty();
      return;
    }
    if (name === 'production_qty' || name === 'purchase_qty' || name === 'received_qty'|| name ==='other_qty' || name ==='client_adjust_qty') {
      setInputs(values => ({...values, [name]: event.target.value}))
      var  productionqty = document.getElementById('production_qty').value;
      console.log(productionqty+"productionqty")
      var purchaseqty = document.getElementById('purchase_qty').value; 
      console.log(purchaseqty+"purchaseqty")
      var receivedqty =  document.getElementById('received_qty').value; 
      console.log(receivedqty+"receivedqty")
      var otherqty = document.getElementById('other_qty').value;
      console.log(otherqty+"otherqty")
      var clientadjustqty = document.getElementById('client_adjust_qty').value;
      console.log(clientadjustqty+"clientadjustqty")
      if((productionqty === '') || (productionqty === NaN) ){
        productionqty = 0;
      }
      if((purchaseqty === '') || (purchaseqty === NaN) ){
        purchaseqty = 0;
      }
      if((receivedqty === '') || (receivedqty === NaN) ){
        receivedqty = 0;
      }
      if((otherqty === '') || (otherqty === NaN) ){
        otherqty = 0;
      }
      if((clientadjustqty === '') || (clientadjustqty === NaN) ){
        clientadjustqty = 0;
      }
      console.log(productionqty+"productionqty")
      var dcqty = parseFloat(productionqty) + parseFloat(purchaseqty) + parseFloat(receivedqty) + parseFloat(otherqty) + parseFloat(clientadjustqty);
      var difference = (dcqty)-initial_dc_qty;
      var cumulative_qty = (parseFloat(initial_cum_qty)+ parseFloat(difference)).toFixed(2)
      console.log(cumulative_qty+"cumulative_qty");
      console.log(parseFloat(dcqty)+"parseFloat(dcqty)");
      setInputs(values => ({...values, ['dc_qty']: dcqty,['cumulative_quantity']:cumulative_qty}))
      const step1 = parseFloat(inputs.dc_qty) / parseFloat(inputs.mixer_capacity);
      const step2 = Math.ceil(step1);
      const step3 = parseFloat(inputs.dc_qty) / step2;
      setInputs((values) => ({...values, ['batch_size']: step3.toFixed(2),
      }));
    }
    setInputs(values => ({...values, [name]: event.target.value}))
  };
  
  const handleChangeWorkscheduleDetails = (event) => {
      const workscheduleId = event.target.value;
      const propertyName = event.target.name;
      if (workscheduleId) {
        setInputs(values =>({...values,[propertyName]:workscheduleId}));
        const selected_ws = allWorkschedules.filter(obj => obj.id == workscheduleId)[0];
        setSelectedWorkSchedule(selected_ws);
        if(selected_ws.sales_order_detail.sales_order.transport_mode === 'customer')
        {
          setInputs(values =>({...values,['transport_mode']:'customer'}))
          document.getElementById('customer_vehicle_no').style.display="block";
          document.getElementById('vehicle_id').style.display="none";
          document.getElementById('transport_mode').disabled = true;
        }
        else if(selected_ws.sales_order_detail.sales_order.transport_mode === 'own')
        {
          setInputs(values =>({...values,['transport_mode']:'own'}))
          document.getElementById('customer_vehicle_no').style.display="none";
          document.getElementById('vehicle_id').style.display="block";
          document.getElementById('transport_mode').disabled = true;
        }
        else{
          setInputs(values =>({...values,['transport_mode']:'own'}))
          document.getElementById('transport_mode').disabled = false;
          document.getElementById('customer_vehicle_no').style.display="none";
          document.getElementById('vehicle_id').style.display="block";
        }
        setInputs(values =>({...values,
            ['production_grade_id']:selected_ws.sales_order_detail.product.id,
            ['purchase_grade_id']:selected_ws.sales_order_detail.product.id,
            ['received_grade_id']: selected_ws.sales_order_detail.product.id,
            ['other_grade_id']: selected_ws.sales_order_detail.product.id,
            ['dc_grage_id']:  selected_ws.sales_order_detail.product.id,
            ['schedule_qty']:selected_ws.scheduled_qty,
            ['balance_qty']:selected_ws.balance_qty,
            ['mixer_capacity']:selected_ws.plant.mixer_capacity,
            ['slump']: selected_ws.slump1 != null ? selected_ws.slump1 : 0,
        }));
        setIsLoading(true);
        getCompanyDetails(cookies,selected_ws.sales_order_detail.sales_order.company.id)  //get plant list
        .then(company =>{
            setIsLoading(false);
            setFilteredPlants(company.plants.map( plant =>{
                return {value: plant.id,label : plant.alias}
            }));
        });
      }
  }
      
  const handleDeliveryChallanDetails = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    if(name === "creation_date"){
      setInputs(values => ({...values, 'delivery_challan_date': event.target.value}))
    } else {
      setInputs(values => ({...values, 'delivery_challan_time': event.target.value}))
    }
  }
  
  const updateDCNumberAndPrefix = (prefix, serial_no) => {
    setInputs(values => ({...values,
        ['delivery_challan_num_prefix']:(prefix+serial_no),
        ['delivery_challan_no']:serial_no,
        ['prefix']:prefix}));
  } 

  const showCustomerDetails = () => {
    showBillingPop(selectedCustomer);
  }
      
  const showSiteDetails = () => {
    if (selectedWorkSchedule.id) {
        getCustomerSiteDetails(cookies,selectedWorkSchedule.sales_order_detail.sales_order.consignee.id)
        .then(consignee => {
            showCustomerSitePop(consignee);
        })
    }
  }
  
  const showProjectDetails = () => {
      if (selectedWorkSchedule.id) {
          getCustomerSiteDetails(cookies,selectedWorkSchedule.sales_order_detail.sales_order.consignee.id)
          .then(delivery_details => {
            showProjectrPop(delivery_details);
          })
      }
  }

  const showWorkScheduleDetails = () => {
    if (selectedWorkSchedule.id) {
         showWorkschedulePop(selectedWorkSchedule);
    }
  }

  const showSalesOrderDetails = () => {
    if (selectedWorkSchedule.id) {
      showSalesorderPop(selectedWorkSchedule);
    }
  }
  
  const showDesignMixTable = () =>{
    if (selectedWorkSchedule.id) {
      getDesignMixForWorkSchedule(cookies,selectedWorkSchedule.id)
      .then(designmix_list => {
          openDesignMixPopup({
            cookies,
            designmix_list,
            plantConfig,
            plantId: inputs.production_plant_id || inputs.plant_id || selectedWorkSchedule?.plant?.id,
          });
      })
    }
  }

  const constructFormData = () => {
    const ownVehicleId = (() => {
      if (inputs.transport_mode === 'customer') return '';
      const raw = selectedVehicle?.value ?? selectedVehicle;
      const id = parseInt(raw, 10);
      return Number.isFinite(id) && id > 0 ? id : '';
    })();
    return {
        id :inputs.id,
        plant_id:parseInt(inputs.plant_id) ,
        production_plant_id:parseInt(inputs.production_plant_id),
        work_schedule_id:parseInt(inputs.work_schedule_id),
        delivery_challan_no:inputs.delivery_challan_no,
        delivery_challan_date:getDisplayDate(inputs.delivery_challan_date),
        delivery_challan_time:inputs.delivery_challan_time,
        prefix:inputs.prefix,
        production_grade_id:parseInt(inputs.production_grade_id),
        purchase_grade_id:parseInt(inputs.purchase_grade_id),
        received_grade_id:parseInt(inputs.received_grade_id),
        other_grade_id:parseInt(inputs.other_grade_id),
        production_qty:inputs.production_qty?parseFloat(inputs.production_qty):0,
        purchase_qty:inputs.purchase_qty?parseFloat(inputs.purchase_qty):0,
        other_qty:inputs.other_qty?parseFloat(inputs.other_qty):0,
        received_qty:inputs.received_qty?parseFloat(inputs.received_qty):0,
        balance_qty:parseFloat(inputs.balance_qty),
        mixer_capacity:parseFloat(inputs.mixer_capacity),
        client_adjust_qty:inputs.client_adjust_qty?parseFloat(inputs.client_adjust_qty):0,
        is_client_adj_qty_incld_inv:inputs.is_client_adj_qty_incld_inv?parseBoolean(inputs.is_client_adj_qty_incld_inv):true,
        dc_qty:parseFloat(inputs.dc_qty),
        vehicle_id: ownVehicleId,
        transport_mode:inputs.transport_mode,
        customer_vehicle_no:inputs.transport_mode === 'customer' ? (inputs.customer_vehicle_no || '') : '',
        // customer_vehicle_no:selectedOptionCustomerVehicles.value,
        operator_name:selectedOperator?selectedOperator.value:'',
        cumulative_sl_no: parseInt(inputs.cumulative_serial_no),
        cumulative_qty:inputs.cumulative_quantity?parseFloat(inputs.cumulative_quantity):0,
        batch_size:parseFloat(inputs.batch_size),
        batch_no:parseInt(inputs.batch_no),
        user_remarks:inputs.user_remarks,
        checkout_no:inputs.checkout_no != null && inputs.checkout_no !== '' ? inputs.checkout_no : 0,
        checkout_date:getDisplayDate(inputs.checkout_date),
        checkout_time:inputs.checkout_time,
        gross_weight: Math.round(Number(inputs.gross_weight) || 0),
        net_weight: Math.round(Number(inputs.net_weight) || 0),
        tare_weight: Math.round(Number(inputs.tare_weight) || 0),
        weighment_slip_time:inputs.weighment_slip_time || getCurrentTime(),
        weighment_slip_no:inputs.weighment_slip_no || '',
        weighment_slip_date: getDisplayDate(inputs.weighment_slip_date || getCurrentDate()),
        driver_name:selectedDriver?selectedDriver.value:'',
        driver_mobile_no:inputs.driver_mobile_no || '',
        opening_km:parseInt(inputs.opening_km) || 0,
        opening_hm:parseInt(inputs.opening_hm) || 0,
        slump:parseInt(inputs.slump) || 0
    }
  } 
      
 //If all the required fields are filled u can select the save button then choose the option yes or no
  const handleSubmit = (event) => {
    event.preventDefault();
    try {
      if (!((Object.values(error).every(x => !x)) && isSubmitting)) {
        Swal.fire('Please check * marked fields are filled and details given are valid...', '', 'info');
        return;
      }
      if (inputs.transport_mode === 'own') {
        const raw = selectedVehicle?.value ?? selectedVehicle;
        const id = parseInt(raw, 10);
        if (!Number.isFinite(id) || id <= 0) {
          Swal.fire('Vehicle', 'Please select a valid own vehicle.', 'warning');
          return;
        }
      }
      if (inputs.transport_mode === 'customer' && !(inputs.customer_vehicle_no || '').trim()) {
        Swal.fire('Vehicle', 'Please enter customer vehicle number.', 'warning');
        return;
      }
      if (!inputs.production_plant_id) {
        Swal.fire('Production Plant', 'Please select production plant.', 'warning');
        return;
      }
      const weighmentError = getWeighmentValidationError(inputs, { requireActualVsDcQty: true });
      if (weighmentError) {
        Swal.fire('Weighment Details', weighmentError, 'warning');
        return;
      }
      Swal.fire({
        title: 'Confirm Delivery Challan',
        html: buildDcSaveConfirmHtml(
          getDcConfirmContext({
            selectedWorkSchedule,
            inputs,
            selectedVehicle,
            finishedgoods,
          }),
          { actionLabel: 'update' },
        ),
        width: 520,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        cancelButtonText: `No`,
        }).then((result) => {  
          if (result.isConfirmed) 
          { 
            updateDeliveryChallan(cookies, constructFormData(),id)
            .then(function (response) {
              clearFormDraft(DELIVERY_CHALLAN_EDIT_DRAFT_KEY);
              Swal.fire('Updated!', '', 'success') 
              view();
            })
            .catch((error) =>
            {
              console.log(error?.response?.data);
              displayDeliveryChallanSaveError({
                errorData: error?.response?.data || error?.message || error,
                title: 'Update Failed',
                vehicleId: selectedVehicle?.value,
                navigate,
                returnTo: location.pathname,
                onBeforeRedirect: saveEditDraft,
              });
            })
            
          } 
          else if (result.isDismissed) 
          {    
            Swal.fire('Not Updated', '', 'info')  
          }
        });
    } catch (e) {
      console.error(e);
      displayErrorToast(e);
      Swal.fire('Update Failed', e?.message || 'Unexpected error while preparing update.', 'error');
    }
  }

  React.useEffect(() => {
    if (isRestoredEdit) {
      return;
    }
    getAllProducts(cookies)
    .then (
        productList => {
            setFinishedGoods( 
              productList.product_list.filter(product => product.status && product.category.name === 'FINISHED GOODS')
                .map(
                    product => {
                        return { value: product.id, label: product.name }
                    }
                ));
        }
    );  
    getDropdownOptions(cookies)
        .then (
          response => {
            setOptions(response.operators.map(
                  obj => {
                      return { value: obj, label: obj }
                  }
              ))
            setDrivers(response.drivers.map(
              obj => {
                  return { value: obj, label: obj }
              }
          ))
            setCustomerVehicles(response.customer_vehicles.map(
              obj => {
                  return { value: obj, label: obj }
              }
          ))
          //   setOptions(values =>([...values,response.operators.map(
          //     obj => {
          //         return { value: obj, label: obj }
          //     }
          // )]));
          //   setDrivers(values =>([...values,response.drivers.map(
          //     obj => {
          //         return { value: obj, label: obj }
          //     }
          // )]));
          //   setCustomerVehicles(values =>([...values,response.customer_vehicles.map(
          //     obj => {
          //         return { value: obj, label: obj }
          //     }
          // )]));
          }
        )
    document.getElementById('customer_vehicle_no').style.display="none";
    if (id) {
  setInProgress(true);

  getDeliveryChallanDetails(cookies, id)
  .then(deliverychallan_object => {
    setInProgress(false);
    if (!deliverychallan_object?.id) {
      displayError(deliverychallan_object || 'Delivery challan details not found.', 'Loading Failed');
      return;
    }
    const vehicle = deliverychallan_object.vehicle || {};
    const workSchedule = deliverychallan_object.work_schedule || {};
    const wsPlant = workSchedule.plant || {};
    const salesOrderDetail = workSchedule.sales_order_detail || {};
    const salesOrder = salesOrderDetail.sales_order || {};
    const consignee = salesOrder.consignee || {};
    const customer = consignee.customer || {};
    setInputs({...deliverychallan_object, 
        ['id']:deliverychallan_object.id,
        ['plant_id']:wsPlant.id,
        ['production_plant_id']:deliverychallan_object.production_plant?.id,
        ['work_schedule_id']:workSchedule.id,
        ['delivery_challan_no']:deliverychallan_object.delivery_challan_no,
        ['delivery_challan_date']:getDisplayDate(deliverychallan_object.delivery_challan_date),
        ['delivery_challan_time']:deliverychallan_object.delivery_challan_time,
        ['prefix']:deliverychallan_object.prefix,
        ['production_grade_id']:deliverychallan_object.production_grade?.id,
        ['purchase_grade_id']:deliverychallan_object.purchase_grade?.id,
        ['received_grade_id']:deliverychallan_object.received_grade?.id,
        ['other_grade_id']:deliverychallan_object.other_grade?.id,
        ['production_qty'] :parseFloat(deliverychallan_object.production_qty),
        ['purchase_qty']:parseFloat(deliverychallan_object.purchase_qty),
        ['other_qty']:parseFloat(deliverychallan_object.other_qty),
        ['received_qty']:parseFloat(deliverychallan_object.received_qty),
        ['schedule_qty']:parseFloat(workSchedule.schedule_qty),
        ['balance_qty']:parseFloat(workSchedule.balance_qty),
        ['mixer_capacity']:parseFloat(wsPlant.mixer_capacity),
        ['client_adjust_qty']:parseFloat(deliverychallan_object.client_adjust_qty),
        ['is_client_adj_qty_incld_inv'] :parseBoolean(workSchedule.is_client_adj_qty_incld_inv),
        ['dc_qty'] :parseFloat(deliverychallan_object.dc_qty),
        ['vehicle_id'] :vehicle.id,
        ['transport_mode'] :deliverychallan_object.transport_mode,
        ['customer_vehicle_no']:deliverychallan_object.customer_vehicle_no,
        // ['operator_name'] :deliverychallan_object.operator_name,
        ['cumulative_serial_no'] :deliverychallan_object.cumulative_sl_no,
        ['cumulative_quantity'] :parseFloat(deliverychallan_object.cumulative_qty),
        ['batch_size'] :parseFloat(deliverychallan_object.batch_size),
        ['batch_no'] :parseInt(deliverychallan_object.batch_no),
        ['user_remarks'] :deliverychallan_object.user_remarks,
        ['editing_details'] :deliverychallan_object.editing_details,
        ['is_schedule_completed']:workSchedule.is_schedule_completed,
        ['status']: deliverychallan_object.status,
        ...(() => {
          const tare = Math.round(Number(deliverychallan_object.tare_weight) || 0);
          const actual = Math.round(Number(
            deliverychallan_object.br_actual_weight ?? deliverychallan_object.net_weight
          ) || 0);
          return {
            tare_weight: tare,
            net_weight: actual,
            gross_weight: tare + actual,
            br_actual_weight: actual,
          };
        })(),
        ['weighment_slip_time']: deliverychallan_object.weighment_slip_time || getCurrentTime(),
        ['weighment_slip_no']: deliverychallan_object.weighment_slip_no,
        ['weighment_slip_date']: getDisplayDate(deliverychallan_object.weighment_slip_date) || getCurrentDate(),
        // ['driver_name']: deliverychallan_object.driver_name,
        ['driver_mobile_no']: deliverychallan_object.driver_mobile_no,
        ['opening_km']: deliverychallan_object.opening_km,
        ['opening_hm']: deliverychallan_object.opening_hm,
        ['slump']: deliverychallan_object.slump});
        setSelectedVehicle(vehicle.id
          ? {'label': vehicle.name || '', 'value': vehicle.id, empty_weight: Number(vehicle.empty_weight) || 0}
          : '');
        if (deliverychallan_object.operator_name) {
          setSelectedOperator({
            value: deliverychallan_object.operator_name,
            label: deliverychallan_object.operator_name
          });
        }
        if (deliverychallan_object.driver_name) {
          setSelectedDriver({
            value: deliverychallan_object.driver_name,
            label: deliverychallan_object.driver_name
          });
        }
        // setSelectedOperator(deliverychallan_object.operator_name)
        setInitialDcQty(deliverychallan_object.dc_qty)
        setInitialCumQty(deliverychallan_object.cumulative_qty)
        setIsCheckedIn(Boolean(deliverychallan_object.is_checked_in));

        if(deliverychallan_object.transport_mode === 'own'){
          document.getElementById('customer_vehicle_no').style.display="none";
          document.getElementById('vehicle_id').style.display="block";
        }
        else {
          document.getElementById('customer_vehicle_no').style.display="block";
          document.getElementById('vehicle_id').style.display="none";
        }
        if ((salesOrder.transport_mode === 'own')||(salesOrder.transport_mode === 'customer')){
          document.getElementById('transport_mode').disabled=true;
        }
      
      if (vehicle.id) {
        setEquipments(equipments => [...equipments, 
            ({['value']: vehicle.id,
              ['label']: vehicle.name || '',
              empty_weight: Number(vehicle.empty_weight) || 0})
          ]);
      }
        setSelectedWorkSchedule(workSchedule);  
        
      

        if (salesOrder.company?.id) {
          getCompanyDetails(cookies,salesOrder.company.id)  //get plant list
          .then(company =>{
              setIsLoading(false);
              setFilteredPlants((company?.plants || []).map( plant =>{
                  return {value: plant.id,label : plant.alias}
              }));
          })
          .catch(() => setIsLoading(false));
        } else {
          setIsLoading(false);
        }
      
      if (wsPlant.id) {
        getAllPlantConfigurations(cookies,wsPlant.id)
        .then (
            plantConfigList => {
                setPlantConfig(plantConfigList);
            }
        )
      }

        if (customer.id) {
          getCustomerMainDetails(cookies,customer.id)    
              .then(customerObject => {              //Set the details of the customer in the form fields
                  setSelectedCustomer(customerObject)
                  })
        }
        if (consignee.id) {
          getCustomerSiteDetails(cookies,consignee.id)
          .then(customerObject => {                     //Set the details of the customer in the form fields

            
              setSelectedSite(customerObject);
          });
        }
        if (wsPlant.id) {
          getPlantDetails(cookies,wsPlant.id)  //get plant list
                  .then(plants =>{
                  
                          return {value: plants.id,label : plants.name}
                          
                      })
        }

        // getSalesOrderDetails(cookies,deliverychallan_object.sales_order_detail.sales_order.id)
        if (salesOrder.id) {
          getSalesOrderDetails(cookies,salesOrder.id)
            .then(salesorder =>{
                
              return {value: salesorder.id,label : salesorder.name}
          
          })
        }
        // getDesignMixForWorkSchedule(cookies,deliverychallan_object.selectedWorkSchedule.sales_order_detail.id)
        if (salesOrderDetail.id) {
          getDesignMixForWorkSchedule(cookies,salesOrderDetail.id)          
          .then(designmix_list => {
                      return {value: designmix_list.id,label : designmix_list.name}
                    })
        }
        getAllEquipments(cookies)
                  .then (
                          equipmentObject => {
                        // console.log(JSON.stringify(equipmentObject)+"getAllEquipments")
                            const equipments = (equipmentObject?.equipment_list || []).filter(obj => ((obj.equip_type?.name === 'TRANSIT MIXER')&& (obj.status))).map(
                                equipment => {
                                  console.log(JSON.stringify(equipment)+"equipment")
                                    if(equipment.is_equip_ready){
                                      return { value: equipment.id, label: equipment.equip_name, empty_weight: Number(equipment.empty_weight) || 0, co_open_km: Number(equipment.co_open_km) || 0, co_open_hm: Number(equipment.co_open_hm) || 0 }
                                    }
                                    else if((deliverychallan_object.transport_mode === 'own') && (equipment.id === vehicle.id)){
                                      return { value: equipment.id, label: equipment.equip_name, empty_weight: Number(equipment.empty_weight) || 0, co_open_km: Number(equipment.co_open_km) || 0, co_open_hm: Number(equipment.co_open_hm) || 0 }
                                    }
                                    // If neither condition is met, return null
                                    return null; 
                                }
                            ).filter((equipment) => equipment !== null);
                            console.log(JSON.stringify(equipments)+"equipments")
                            setEquipments(equipments);
                            setSelectedVehicle((prev) => {
                              if (!prev?.value) {
                                return prev;
                              }
                              const match = equipments.find((item) => String(item.value) === String(prev.value));
                              return match ? { ...prev, empty_weight: match.empty_weight, co_open_km: match.co_open_km, co_open_hm: match.co_open_hm } : prev;
                            });
                        }
                    )       
                  
  })
  .catch(error => {
    setInProgress(false);
    setIsLoading(false);
    console.log(error+"error")
    displayError(error?.response?.data || error?.message || error, "Loading Failed");
  });
    }
  }, []);

  const onDeleteDeliveryChallan = (event) => {
    event.preventDefault();
    Swal.fire({title: 'Are you sure to Delete?',  
    showCancelButton: true,  
    confirmButtonText: `Yes`,
    cancelButtonText: `No`,
    }).then((result) => {  
      if (result.isConfirmed) { 
        setIsLoading(true);
        deleteDeliveryChallan(cookies, id)
        .then(response => {
            console.log(`Delivery Challan with id ${id} deleted`);
            Swal.fire('Deleted Successfully!', '', 'success');
            view();
        })
        .catch(error => {
            console.log(error?.response?.data);
            displayError(error?.response?.data || error?.message || error,'Delete Failed');
        }); 
        }
      else if (result.isDismissed) {    
        Swal.fire('Not Deleted', '', 'info')  
      }
    });
  };

  const onCancelDeliveryChallan = (event) => {
    event.preventDefault();
    Swal.fire({title: 'Do you want to cancel the Delivery Challan?',  
    showCancelButton: true,  
    confirmButtonText: `Yes`,
    cancelButtonText: `No`,
    }).then((result) => {  
      if (result.isConfirmed) { 
        setIsLoading(true);
        cancelDeliveryChallan(cookies, id)
        .then(response => {
            console.log(`Delivery Challan with id ${id} canceled`);
            Swal.fire('Cancel Successfully!', '', 'success');
            view();
        })
        .catch(error => {
            console.log(error?.response?.data);
            displayError(error?.response?.data || error?.message || error,'Cancel Failed');
        }); 
      }
      else if (result.isDismissed) {    
        Swal.fire('Not Canceled', '', 'info')  
      }
    });
  };

  const onReactivateDeliveryChallan = (event) => {
    event.preventDefault();
    Swal.fire({
      title: 'Reactivate this cancelled Delivery Challan?',
      text: 'It will become Active again and work-schedule balance will be recalculated.',
      showCancelButton: true,
      confirmButtonText: 'Yes, Reactivate',
      cancelButtonText: 'No',
    }).then((result) => {
      if (!result.isConfirmed) {
        Swal.fire('Not Reactivated', '', 'info');
        return;
      }
      setIsLoading(true);
      reactivateDeliveryChallan(cookies, id)
        .then(() => {
          Swal.fire('Reactivated Successfully!', '', 'success');
          view();
        })
        .catch((error) => {
          displayError(error?.response?.data || error?.message || error, 'Reactivate Failed');
        })
        .finally(() => setIsLoading(false));
    });
  };

  const onEmailDeliveryChallan = (event) => {
    event.preventDefault();
    Swal.fire({title: 'Do you want to send the Email?',  
    showCancelButton: true,  
    confirmButtonText: `Yes`,
    cancelButtonText: `No`,
    }).then((result) => {  
      if (result.isConfirmed) { 
        setIsLoading(true);
        getDeliveryChallanEmail(cookies, id)
        .then(response => {
            console.log(`Delivery Challan with id ${id} Email`);
            Swal.fire('Email Sent Successfully!', '', 'success');
            view();
        })
        .catch(error => {
            console.log(error?.response?.data);
            displayError(error?.response?.data || error?.message || error,'Email Failed');
        }); 
      }
      else if (result.isDismissed) {    
        Swal.fire('Not EmailID', '', 'info')  
      }
    });
  };

  const validate_items = (name,value,regular_expr,error_message) =>
  {
      try{
        if(value.trim())     //If  required condition is valid it accept ,otherwise it is Invalid.
        {
            if(!regular_expr.test(value.trim())) //If regex is not statisfied ,then it is false
            {
              console.log(value+"value");
              setError(values => ({...values, [name]: error_message}))
              setIsSubmitting(false); 
            }
            else            //If regex is statisfied ,then it is true
            {
              setError(values => ({...values, [name]: ''}))
              setIsSubmitting(true);
            }
        }
        // else                 //If value must not be empty this condition is false
        // {
        //     setError(values => ({...values, [name]: 'must not be empty...'}))
        //     setIsSubmitting(false);
        // }                    // If condition is valid then display the values
        setInputs(values => ({...values, [name]: value}))
      }
      catch (e)
      {
        displayErrorToast(e);
      }
  }

  const handleChangeWeightDetails = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };
       
  const Reload = () => {
    window.location.reload();
  }  

  const Cancel = () => {
    clearFormDraft(DELIVERY_CHALLAN_EDIT_DRAFT_KEY);
    setInputs(() => "")
  }

  const view = () => {
    clearFormDraft(DELIVERY_CHALLAN_EDIT_DRAFT_KEY);
    navigate('/DeliveryChallanTable')
  }

  const soTransportMode = selectedWorkSchedule?.sales_order_detail?.sales_order?.transport_mode;
  const lockTransportMode = isCheckedIn || soTransportMode === 'own' || soTransportMode === 'customer';
  const qtyFieldsEnabled = isDcVehicleReady(inputs, selectedVehicle) && !isCheckedIn;
  const qtyFieldStyle = qtyFieldsEnabled ? undefined : { cursor: 'not-allowed', backgroundColor: '#f1f5f9' };

  return (
    <>
      <Sidebar pageWrapId={'page-wrap'} outerContainerId={'outer-container'} />
      <ErrorToast/>
      <LoadingOverlay inProgress={inProgress}/>
      <div id="page-wrap">
        <form onSubmit={handleSubmit} noValidate>
          <PremiumPageHeader
              module="DISPATCH"
              title="Update Delivery Challan"
              subtitle="Edit delivery challan quantities and vehicle details."
              modeLabel="EDIT MODE"
            />
          <FloatingControls
            tableLink="/DeliveryChallanTable"
            formLink="/DeliveryChallan"
            addNewLabel="New Delivery Challan"
            onFormLinkClick={() => navigateToNewForm(navigate, '/DeliveryChallan', [
              DELIVERY_CHALLAN_CREATE_DRAFT_KEY,
              DELIVERY_CHALLAN_EDIT_DRAFT_KEY,
            ])}
            onCancel={Cancel}
            enableCancel={true}
          />
          <div className="container">
            <Row>
              <Col xl={12} lg={12} md={12} >   
                <div className="form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 form-control-panel dc-ws-details-panel">
                  <div className="col-12 p-0">
                    <DeliveryChallanScheduleBanner
                      visible={Boolean(selectedWorkSchedule?.id)}
                      customer={selectedWorkSchedule?.sales_order_detail?.sales_order?.consignee?.customer?.name || ''}
                      site={selectedWorkSchedule?.sales_order_detail?.sales_order?.consignee?.project_name || ''}
                      soNo={`${selectedWorkSchedule?.sales_order_detail?.sales_order?.prefix || ''}${selectedWorkSchedule?.sales_order_detail?.sales_order?.order_no || ''}`}
                      scheduleQty={inputs.schedule_qty}
                      balanceQty={inputs.balance_qty}
                      cumSlNo={inputs.cumulative_serial_no}
                      cumQty={inputs.cumulative_quantity}
                    />
                  </div>

                  <label htmlFor="plant_id" className="form-group col-sm-2 text-right"> Plant Location: </label>
                  <select id="plant_id"name="plant_id" className="form-control col-sm-3  browser-default custom-select  mandatory-form-control"  required disabled={true} onChange={handleChange} value={inputs.plant_id || ""}>
                          <option value="">Select plant</option>
                          {plants.map((item) => (
                          <option key={item.value} value={item.value}>
                              {item.label}</option>
                          ))}
                  </select>
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;

                  <label htmlFor="work_schedule_id" className="form-group col-sm-2 text-right"> Work Schedule</label>
                  <select id="work_schedule_id"name="work_schedule_id" className="form-control col-sm-3  browser-default custom-select  mandatory-form-control"  required disabled={true} onChange={ handleChangeWorkscheduleDetails} value={inputs.work_schedule_id || ""}>
                          <option value="">Select Work Schedule</option>
                          {workschedules.map((item) => (
                          <option key={item.value} value={item.value}>
                              {item.label}</option>
                          ))}
                  </select>
                  <SummaryIcon onClickHandler={showWorkScheduleDetails}/> &nbsp;
                  <DmixIcon onClickHandler={showDesignMixTable}/>
                </div>
              </Col>
              <Col xl={6} lg={12} md={12}>
                <div className="form-row table-bordered shadow p-2 my-2  border-secondary p-2 mb-3 form-control-panel ">
                  <label htmlFor="production_plant_id" className="form-group col-sm-4 text-right"> Production Plant </label>
                  <select id="production_plant_id"name="production_plant_id" className="form-control col-sm-7  browser-default custom-select  mandatory-form-control"  required onChange={handleChange} value={inputs.production_plant_id || ""}>
                    <option value="">Select plant</option>
                    {filteredplants.map((item) => (
                        <option key={item.value} value={item.value}>{item.label}</option>
                    ))}
                  </select>

                  <label htmlFor="batch_no" className="form-group col-sm-4 text-right">Batch No</label>
                  <input type="number" onChange={handleChange} name="batch_no"  className="form-control col-sm-7  mandatory-form-control" id="batch_no"  value={inputs.batch_no || ""}  /><br />

                  <label htmlFor="production_grade_id" className="form-group col-sm-4 text-right">Production Grade | Qty </label>
                  <select id="production_grade_id"name="production_grade_id" className="form-control col-sm-4  browser-default custom-select  mandatory-form-control" required type="number" min="0"  onChange={handleChange} value={inputs.production_grade_id || ""}>
                    {/* {(selectedWorkSchedule.id ? 
                      <option value="{selectedWorkSchedule.sales_order_detail.product.id}">{selectedWorkSchedule.sales_order_detail.product.name}</option>
                      : null
                    )} */}
                     {finishedgoods.map((item) => (
                        <option key={item.value} value={item.value}>{item.label}</option>
                    ))}
                  </select>   
                  
                  <input required type="number" step="any" min="0" value={inputs.production_qty || 0} onChange={handleDeliveryChallanQty} onFocus={() => { if (!qtyFieldsEnabled) promptSelectVehicleBeforeQty(); }} name="production_qty" id="production_qty" className="form-control col-sm-3" readOnly={!qtyFieldsEnabled} style={qtyFieldStyle} />

                  <label htmlFor="purchase_grade_id" className="form-group col-sm-4 text-right">Purchase Grade | Qty </label>
                  <select id="purchase_grade_id"name="purchase_grade_id" className="form-control col-sm-4  browser-default custom-select  mandatory-form-control" required type="number" min="0"  onChange={handleChange} value={inputs.purchase_grade_id||""}>
                    {finishedgoods.map((item) => (
                        <option key={item.value} value={item.value}>{item.label}</option>
                    ))}
                  </select>   

                  <input required type="number" min="0"  step="any" value={inputs.purchase_qty || 0} onChange={handleDeliveryChallanQty} onFocus={() => { if (!qtyFieldsEnabled) promptSelectVehicleBeforeQty(); }} name="purchase_qty" id="purchase_qty" className="form-control col-sm-3" readOnly={!qtyFieldsEnabled} style={qtyFieldStyle} />

                  <label htmlFor="received_grade_id" className="form-group col-sm-4 text-right">Receive Grade | Qty </label>
                  <select id="received_grade_id"name="received_grade_id" className="form-control col-sm-4  browser-default custom-select  mandatory-form-control" required type="number" min="0"  onChange={handleChange} value={inputs.received_grade_id||""}>
                    {finishedgoods.map((item) => (
                        <option key={item.value} value={item.value}>{item.label}</option>
                    ))}
                  </select>  

                  <input required type="number" min="0"  step="any" value={inputs.received_qty || 0} onChange={handleDeliveryChallanQty} onFocus={() => { if (!qtyFieldsEnabled) promptSelectVehicleBeforeQty(); }} id="received_qty" name="received_qty" className="form-control col-sm-3" readOnly={!qtyFieldsEnabled} style={qtyFieldStyle} />

                  <label htmlFor="other_grade_id" className="form-group col-sm-4 text-right">Other Grade | Qty </label>
                  <select id="other_grade_id" name="other_grade_id" className="form-control col-sm-3  browser-default custom-select  mandatory-form-control" required type="number" min="0"  onChange={handleChange} value={inputs.other_grade_id||""}>
                    {finishedgoods.map((item) => (
                        <option key={item.value} value={item.value}>{item.label}</option>
                    ))}
                    </select>   
                  <input required type="number" min="0"  step="any" name="other_qty" value={inputs.other_qty || 0} onChange={handleDeliveryChallanQty} onFocus={() => { if (!qtyFieldsEnabled) promptSelectVehicleBeforeQty(); }} id="other_qty" className="form-control col-sm-4" readOnly={!qtyFieldsEnabled} style={qtyFieldStyle} />

                  <label htmlFor="client_adjust_qty" className="form-group col-sm-4 text-right">Client Adjust | Qty </label>
                  <input type="number" min="0"  step="any" value={inputs.client_adjust_qty || 0} onChange={handleDeliveryChallanQty} onFocus={() => { if (!qtyFieldsEnabled) promptSelectVehicleBeforeQty(); }} name="client_adjust_qty" id="client_adjust_qty" className="form-control col-sm-7" readOnly={!qtyFieldsEnabled} style={qtyFieldStyle} />
                  
                  <label htmlFor="is_client_adj_qty_incld_inv" className="form-group col-sm-4 text-right">Client Adjust|Qty Invoice</label>
                  <select id="is_client_adj_qty_incld_inv" name="is_client_adj_qty_incld_inv" className="form-control col-sm-7  browser-default custom-select"  onChange={handleChange} value={inputs.is_client_adj_qty_incld_inv || ""}>
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select><br />
                  
                  <label htmlFor="dc_qty" className="form-group col-sm-4 text-right">DC Grade|Qty</label>
                  <select id="dc_qty"name="dc_qty" className="form-control col-sm-4  browser-default custom-select  mandatory-form-control" required type="number"  step="any"  onChange={handleChange} value={inputs.dc_qty ||0
                  }>
                  {(selectedWorkSchedule.id ? 
                      <option value="{selectedWorkSchedule.sales_order_detail.product.id}">{selectedWorkSchedule.sales_order_detail.product.name}</option>
                      : null)}
                  </select>   
                  <input required type="number"  step="any" min="0" value={inputs.dc_qty || 0}   className="form-control col-sm-3" name="dc_qty" id="dc_qty"/>
                </div>
              </Col>
              <Col xl={6} lg={12} md={12}>
                  <div className="form-row table-bordered shadow p-2 my-2 border-secondary p-2 mb-3 form-control-panel">
                    <NumberSetting 
                      handleDateChange={handleDeliveryChallanDetails} 
                      serial_no={inputs.delivery_challan_no} 
                      creation_date={inputs.delivery_challan_date}
                      creation_time={inputs.delivery_challan_time}
                      prefix={inputs.prefix}
                      company_id={inputs.company_id}
                      voucher_type={"delivery_challan"}
                      handleNumberAndPrefixUpdate={updateDCNumberAndPrefix}
                      cookies={cookies}
                      serial_no_title={'DeliveryChallan No'}
                      hideTime={false}/>

                    <label htmlFor="transport_mode" className="form-group col-sm-4 text-right">Mode of Transport</label>
                    <select id="transport_mode"name="transport_mode" className="form-control col-sm-7  mandatory-form-control" onChange={handleChange} value={inputs.transport_mode || ""} required disabled={lockTransportMode}>
                        <option value="own" >Own</option>
                        <option value="customer" >Customer</option>
                    </select><br/>

                    <label htmlFor="vehicle_id" className="form-group col-sm-4 text-right">Vehicle No</label>
                       <div id ="vehicle_id" className="col-sm-7 mandatory-form-control">
                        <Select
                        options={equipments}
                        onChange={handleVehicleChange}
                        value={selectedVehicle}
                        placeholder="Select a Vehicle..."
                        isSearchable
                        isDisabled={isCheckedIn}
                      />
                      </div>
                    <input type="text" className="form-control col-sm-7 mandatory-form-control" id="customer_vehicle_no" value={inputs.customer_vehicle_no || ""}  name="customer_vehicle_no" onChange={handleChange} disabled={isCheckedIn} /><br />

                    <label htmlFor="operator_name" className="form-group col-sm-4 text-right">Plant Operator Name </label>
                    <Creatable
                    options={options}
                    onChange={handleCreatable}
                    value={selectedOperator}
                    placeholder="Type to search or create an option..."
                    className="form-control col-sm-7"
                  />

                    <label htmlFor="user_remarks" className="form-group col-sm-4 text-right">Remarks,if any</label>
                    <input type="text" className="form-control col-sm-7" id="user_remarks" value={inputs.user_remarks}  name="user_remarks" onChange={handleChange}/><br />
                  
                  <div className={`modal dc-weighment-modal ${showModal2 ? 'is-open' : ''}`} tabIndex="-1" style={{ display: showModal2 ? 'flex' : 'none' }}>
                    <div className="modal-dialog dc-weighment-modal-dialog">
                      <div className="modal-content dc-weighment-modal-content">
                        <div className="modal-header dc-weighment-modal-header">
                          <h5 className="modal-title">Weighment Details</h5>
                          <button type="button" className="close text-white" aria-label="Close" onClick={() => setShowModal2(false)}>
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div className="modal-body dc-weighment-modal-body">
                          <div className="form-row">
                            <label htmlFor="weighment_slip_no" className="form-group col-sm-4 text-right">Weightment Slip No.</label>
                            <input type="number" id="weighment_slip_no" name="weighment_slip_no" onChange={handleChange} value={inputs.weighment_slip_no || ""} className="form-control col-sm-7"/>

                            <label htmlFor="weighment_slip_date" className="form-group col-sm-4 text-right">Weightment Date/Time</label>
                            <input type="date" className="form-control col-sm-3 mandatory-form-control" name="weighment_slip_date" value={inputs.weighment_slip_date || ""} id="weighment_slip_date" onChange={handleChange} />
                            <input type="time" id="weighment_slip_time" name="weighment_slip_time" onChange={handleChange} value={inputs.weighment_slip_time || ""} className="form-control col-sm-4 mandatory-form-control"/>

                            <label htmlFor="tare_weight" className="form-group col-sm-4 text-right">Tare Weight</label>
                            <input type="number" name="tare_weight" id="tare_weight" value={inputs.tare_weight || 0} className="form-control col-sm-6" readOnly style={{ backgroundColor: "white", cursor: "not-allowed" }}/>
                            <EditSharpIcon
                              titleAccess="Edit Empty Weight in Equipment"
                              onClick={openEquipmentForEmptyWeight}
                              sx={{ cursor: 'pointer', color: '#1565c0', ml: 0.5, alignSelf: 'center' }}
                            />

                            <label htmlFor="net_weight" className="form-group col-sm-4 text-right">Actual Weight</label>
                            <input type="number" name="net_weight" id="net_weight" value={inputs.net_weight || 0} className="form-control col-sm-7" readOnly style={{ backgroundColor: "white", cursor: "not-allowed" }} title="Sum of actual weights of all mixes from Batching Report"/>

                            <label htmlFor="gross_weight" className="form-group col-sm-4 text-right">Gross Weight</label>
                            <input type="number" id="gross_weight" name="gross_weight" value={inputs.gross_weight || 0} className="form-control col-sm-7" readOnly style={{ backgroundColor: "white", cursor: "not-allowed" }} title="Tare Weight + Actual Weight (all mixes)"/>
                          </div>
                        </div>
                        <div className="modal-footer dc-weighment-modal-footer">
                          <button type="button" className="btn btn-primary" onClick={() => setShowModal2(false)}>Close</button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <label htmlFor="editing_dtl" className="form-group col-sm-4 text-right">Editing Dtls</label>
                  <textarea type="text" className="form-control col-sm-7" id="editing_dtl"  value={inputs.editing_dtl||""} name="editing_dtl" style={{ backgroundColor: "white", cursor: "not-allowed" }} />

                  <label htmlFor="driver_name" className="form-group col-sm-4 text-right">Driver Name</label>
                  <div className="col-sm-7">
                    <Creatable
                      options={drivers}
                      onChange={handleDriver}
                      value={selectedDriver}
                      placeholder="Type to search or create an option..."
                      styles={{
                        container: (base) => ({ ...base, width: '100%' }),
                        control: (base) => ({ ...base, minHeight: '38px' }),
                      }}
                    />
                  </div>

                  <label htmlFor="driver_mobile_no" className="form-group col-sm-4 text-right">Mobile No</label>
                  <div className="col-sm-7">
                    <input type="text" id="driver_mobile_no" name="driver_mobile_no"
                      onChange={handleChange}
                      value={inputs.driver_mobile_no|| ""} pattern="[0-9]{10}" maxLength="10" className="form-control" />
                  </div>
                  {error.driver_mobile_no && (<><strong className="form-group col-sm-12 text-center text-danger">{error.driver_mobile_no}</strong></>)}

                  <label htmlFor="slump" className="form-group col-sm-4 text-right">Slump</label>
                  <div className="col-sm-7">
                    <input type="number" id="slump" name="slump" className="form-control" min="0" value={inputs.slump ?? 0} onChange={handleChange}/>
                  </div>

                  <label htmlFor="vehicle" className="form-group col-sm-4 text-right">Weighment Details</label>
                  <div className="col-sm-7">
                    <EditSharpIcon color="#1565c0" onClick={handleVehicleDetailsIconClick}
                      sx={{ cursor: 'pointer' }} />
                  </div>
                </div>
              </Col>
            </Row>
          </div>
          
          <div className="footer text-center">
              {((superuser['mySuperuser']) || (category['myCategory'].includes("change_del_challan_master") === true)) &&(
                  <Button  type="submit" className="btn btn-twitter" style={{width:"80px",fontWeight:"bold"}} >Update</Button> 
              )}&nbsp;&nbsp;
            
              {((superuser['mySuperuser']) || (category['myCategory'].includes("view_del_challan_master") === true)|| (category['myCategory'].includes("change_del_challan_master") === true) || (category['myCategory'].includes("delete_del_challan_master") === true)) &&(  
                  <Button className="btn btn-twitter" type="button"style={{width:"80px",fontWeight:"bold"}} onClick={view}>View</Button>
              )}&nbsp;&nbsp;

              {((superuser['mySuperuser']) || (category['myCategory'].includes("add_del_challan_master") === true)) &&(
              <Button type="reset" className="btn btn-twitter" style={{width:"80px",fontWeight:"bold"}} onClick={Cancel}>New</Button>
              )}&nbsp;&nbsp;

              {!inputs.is_schedule_completed && inputs.status !== false &&
                  (<>
                      <Button className="btn btn-delete"  type="button"style={{width:"80px",fontWeight:"bold"}}  onClick={onDeleteDeliveryChallan}>Delete</Button>&nbsp;&nbsp;
                      <Button className="btn btn-cancel"  type="button"style={{width:"100px",fontWeight:"bold"}} onClick={onCancelDeliveryChallan}>Cancel DC</Button>&nbsp;&nbsp;
                  </>
              )}
              {!inputs.is_schedule_completed && inputs.status === false && (
                  <Button className="btn btn-twitter" type="button" style={{width:"110px",fontWeight:"bold"}} onClick={onReactivateDeliveryChallan}>Reactivate</Button>
              )}
              &nbsp;&nbsp;
              <Button className="btn btn-email"  type="button"style={{width:"80px",fontWeight:"bold"}}  onClick={onEmailDeliveryChallan}>Email</Button>&nbsp;&nbsp;
          </div>
        </form>
      </div>
    </>
  );
}
export default DeliveryChallanEdit;
